<template>
<div
  class="installation-instructions__resource-container"
  :class="instructions.resourceType === 'video' ? 'installation-instructions__resource-container--video' : ''"
>
  <base-image
    v-if="instructions.resourceType === 'image'"
    :src="instructions.resource"
    width="100%"
    height="auto"
    :id="`${instructions.currentStep}_image`"
    :class="`${instructions.resourceOverridingClass || '' }`"
  />
  <video
    v-if="instructions.resourceType === 'video'"
    :src="instructions.resource"
    :key="instructions.resource"
    :controls="instructions.videoControls"
    :autoplay="instructions.videoAutoPlay"
    :loop="instructions.videoLoop"
    :type="instructions.videoType"
    :poster="instructions.poster"
    muted
    playsinline
    :name="`${instructions.currentStep}_video`"
    :id="`${instructions.currentStep}_video`"
    :text="`${instructions.currentStep}_video`"
  />
</div>
</template>

<script>
import BaseImage from './BaseImage.vue';

export default {
  name: 'BaseResource',
  components: {
    BaseImage,
  },
  props: {
    instructions: {
      type: Object,
      required: true,
    },
  },
}
</script>